/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaCittadinoSubmitForm } from '../model/models';
import { PraticaSubmitResponseDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface SubmitPraticaPerCittadinoRequestParams {
    idTipoPratica: string;
    allParts: { [key: string]: Blob; };
    pratica: PraticaCittadinoSubmitForm;
}


export interface GestionePraticheSubmitPerContoDelCittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Sottomette una pratica per conto di un cittadino. Multipart: part \&#39;pratica\&#39; (JSON, stesso contratto del submit cittadino) + N part \&#39;allegato_&lt;target&gt;_&lt;chiave&gt;\&#39;. Il titolare e\&#39; risolto dal codice fiscale presente in anagrafica.form_data: se l\&#39;utente non esiste viene creato e riceve la mail di verifica (nessuna schermata dedicata). La pratica nasce in RICHIESTA_SOTTOMESSA senza OTP, con origine_richiesta&#x3D;OPERATORE_SUPPORTO e l\&#39;operatore inseritore tracciato. Audience SUPERADMIN | OP_COMUNE | OP_PRATICA con capability GESTIONE sul bando. Response: 201, 400 (CF/email mancanti nel form), 403/404 (bando fuori scope o non visibile; CF di un utente non-CITTADINO), 409 (CF gia\&#39; registrato, race), 422 (validazione form, allegati obbligatori mancanti, email gia\&#39; registrata).
     * 
     * @endpoint post /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/per-cittadino
* @param requestParameters
     */
    submitPraticaPerCittadino(requestParameters: SubmitPraticaPerCittadinoRequestParams, extraHttpRequestParams?: any): Observable<PraticaSubmitResponseDTO>;

}
